import { isAppTypeMpSklad } from '../common/isAppTypeMpSklad'
import { useEffect } from 'react'

export const useSeo = () => {
  useEffect(() => {
    document.title = isAppTypeMpSklad() ? 'MPsklad App - единый склад для маркетплейсов' : 'MPcard App'
  }, [])
}